// This file is auto-generated via CI, do not edit by hand!
export enum FeatureToggles {
  TEAM_TIER = 'team_tier',
  ENTERPRISE_TIER = 'enterprise_tier',
  FREE_TIER = 'free_tier',
  FEATURE_ANTRAG_ZU_PROJEKT_ZUORDNEN = 'feature_antrag_zu_projekt_zuordnen',
  FEATURE_ROLLENVERWALTUNG_KREDITORISCH_DEBITORISCH = 'feature_rollenverwaltung_kreditorisch_debitorisch',
}
